const typeOperation = {
  INCREASE_SCORE_FOR_ADVERTISE_BANNER_ALTERNATIVE: 1,
  INCREASE_SCORE_BY_ADMIN: 2,
  DECREMENT_SCORE_BY_ADMIN: 3,
  DECREMENT_SCORE_BY_TRANSACTION_SCORE_TO_WALLET: 4,
};

const getTypeOperationString = () => {
  let data = [];
  data[typeOperation.INCREASE_SCORE_FOR_ADVERTISE_BANNER_ALTERNATIVE] =
    "افزایش امتیاز بوسیله تبلغ بنری جایگزین";
  data[typeOperation.INCREASE_SCORE_BY_ADMIN] = "افزایش امتیاز بوسیله ادمین";
  data[typeOperation.DECREMENT_SCORE_BY_ADMIN] = "کاهش امتیاز بوسیله ادمین";
  data[typeOperation.DECREMENT_SCORE_BY_TRANSACTION_SCORE_TO_WALLET] =  "کاهش امتیاز بوسیله تبدیل امتیاز نمایش دهنده به شارژ کاربر";
  return data;
};

export default {
  typeOperation,
  getTypeOperationString,
};
